import type { Building } from "building-types/building/buildingTypes";
import { optionSetEntityRelationsFromDoc } from "doc/options/relations/optionSetEntityRelations";
import memo from "../utils/memo";

function select({ doc }: Building) {
  return { doc };
}

function generate({ doc }: ReturnType<typeof select>) {
  return { optionSetEntityRelations: optionSetEntityRelationsFromDoc(doc) };
}

export default memo(select, generate);
